import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Log } from '../../../models/log.model';
import { LogDivision } from '../../../models/log-division';

@Component({
    selector: 'app-log-list',
    templateUrl: './log-list.component.html',
    styleUrls: ['./log-list.component.scss'],
    standalone: false
})
export class LogListComponent implements OnInit {
    @Input() logs: Log[] = [];
    @Input() logDivision: LogDivision = LogDivision.show;
    @Input() shouldTruncate = true;
    @Input() searchInput = '';

    /** Whether this component is embedded in a master-detail layout */
    @Input() embedded: boolean = false;

    /** Currently selected log ID (for highlighting in embedded mode) */
    @Input() selectedId: number | null = null;

    /** Emits when a log is selected in embedded mode */
    @Output() logSelected = new EventEmitter<number>();

    constructor() {
    }

    ngOnInit() {
    }

    onLogSelect(logId: number): void {
        this.logSelected.emit(logId);
    }
}
